"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DOMException = require("domexception/webidl2js-wrapper");

var idlUtils = require("../generated/utils");

var _require = require("../helpers/svg/basic-types"),
    attach = _require.attach,
    detach = _require.detach; // https://svgwg.org/svg2-draft/types.html#ListInterfaces
// Child classes must implement _reserialize()


var List = /*#__PURE__*/function (_idlUtils$supportsPro, _idlUtils$supportedPr, _idlUtils$indexedSetN, _idlUtils$indexedSetE) {
  function List() {
    _classCallCheck(this, List);
  }

  _createClass(List, [{
    key: "_initList",
    value: function _initList(_ref) {
      var element = _ref.element,
          attribute = _ref.attribute,
          _ref$readOnly = _ref.readOnly,
          readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly;
      this._element = element;
      this._attribute = attribute;
      this._attributeRegistryEntry = element.constructor.attributeRegistry.get(attribute);
      this._readOnly = readOnly;
      this._list = [];
      this._version = -1;
    }
  }, {
    key: "_needsResync",
    get: function get() {
      return this._version < this._element._version;
    }
  }, {
    key: "_synchronize",
    value: function _synchronize() {
      if (!this._needsResync) {
        return;
      }

      var value = [];

      if (this._element.hasAttributeNS(null, this._attribute)) {
        value = this._attributeRegistryEntry.getValue(this._element.getAttributeNS(null, this._attribute));
      }

      if (value.length === 0 && this._attributeRegistryEntry.initialValue !== undefined) {
        value = this._attributeRegistryEntry.getValue(this._attributeRegistryEntry.initialValue);
      } // TODO: support non-DOMString lists.


      this._list = value;
      this._version = this._element._version;
    }
  }, {
    key: "_reserialize",
    value: function _reserialize() {
      var elements = this._list;

      this._element.setAttributeNS(null, this._attribute, this._attributeRegistryEntry.serialize(elements)); // Prevent ping-ponging back and forth between _reserialize() and _synchronize().


      this._version = this._element._version;
    }
  }, {
    key: _idlUtils$supportsPro,
    value: function value(index) {
      this._synchronize();

      return index >= 0 && index < this.length;
    }
  }, {
    key: _idlUtils$supportedPr,
    get: function get() {
      this._synchronize();

      return this._list.keys();
    }
  }, {
    key: "length",
    get: function get() {
      this._synchronize();

      return this._list.length;
    }
  }, {
    key: "numberOfItems",
    get: function get() {
      this._synchronize();

      return this._list.length;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._synchronize();

      if (this._readOnly) {
        throw DOMException.create(this._globalObject, ["Attempting to modify a read-only list", "NoModificationAllowedError"]);
      }

      var _iterator = _createForOfIteratorHelper(this._list),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          detach(item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._list.length = 0;

      this._reserialize();
    }
  }, {
    key: "initialize",
    value: function initialize(newItem) {
      this._synchronize();

      if (this._readOnly) {
        throw DOMException.create(this._globalObject, ["Attempting to modify a read-only list", "NoModificationAllowedError"]);
      }

      var _iterator2 = _createForOfIteratorHelper(this._list),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          detach(item);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this._list.length = 0; // TODO: clone non-DOMString list elements.

      attach(newItem, this);

      this._list.push(newItem);

      this._reserialize();
    }
  }, {
    key: "getItem",
    value: function getItem(index) {
      this._synchronize();

      if (index >= this._list.length) {
        throw DOMException.create(this._globalObject, ["The index provided (".concat(index, ") is greater than or equal to the maximum bound (").concat(this._list.length, ")."), "IndexSizeError"]);
      }

      return this._list[index];
    }
  }, {
    key: "insertItemBefore",
    value: function insertItemBefore(newItem, index) {
      this._synchronize();

      if (this._readOnly) {
        throw DOMException.create(this._globalObject, ["Attempting to modify a read-only list", "NoModificationAllowedError"]);
      } // TODO: clone non-DOMString list elements.


      if (index > this._list.length) {
        index = this._list.length;
      }

      this._list.splice(index, 0, newItem);

      attach(newItem, this);

      this._reserialize();

      return newItem;
    }
  }, {
    key: "replaceItem",
    value: function replaceItem(newItem, index) {
      this._synchronize();

      if (this._readOnly) {
        throw DOMException.create(this._globalObject, ["Attempting to modify a read-only list", "NoModificationAllowedError"]);
      }

      if (index >= this._list.length) {
        throw DOMException.create(this._globalObject, ["The index provided (".concat(index, ") is greater than or equal to the maximum bound (").concat(this._list.length, ")."), "IndexSizeError"]);
      } // TODO: clone non-DOMString list elements.


      detach(this._list[index]);
      this._list[index] = newItem;
      attach(newItem, this);

      this._reserialize();

      return newItem;
    }
  }, {
    key: "removeItem",
    value: function removeItem(index) {
      this._synchronize();

      if (this._readOnly) {
        throw DOMException.create(this._globalObject, ["Attempting to modify a read-only list", "NoModificationAllowedError"]);
      }

      if (index >= this._list.length) {
        throw DOMException.create(this._globalObject, ["The index provided (".concat(index, ") is greater than or equal to the maximum bound (").concat(this._list.length, ")."), "IndexSizeError"]);
      }

      var item = this._list[index];
      detach(item);

      this._list.splice(index, 1);

      this._reserialize();

      return item;
    }
  }, {
    key: "appendItem",
    value: function appendItem(newItem) {
      this._synchronize(); // TODO: clone non-DOMString list elements.


      this._list.push(newItem);

      attach(newItem, this);

      this._reserialize();

      return newItem;
    }
  }, {
    key: _idlUtils$indexedSetN,
    value: function value(index, _value) {
      // Note: this will always throw a IndexSizeError.
      this.replaceItem(_value, index);
    }
  }, {
    key: _idlUtils$indexedSetE,
    value: function value(index, _value2) {
      this.replaceItem(_value2, index);
    }
  }]);

  return List;
}(idlUtils.supportsPropertyIndex, idlUtils.supportedPropertyIndices, idlUtils.indexedSetNew, idlUtils.indexedSetExisting);

module.exports = List;